import Autoplay from './shared/autoplay'
import Animations from './shared/animations'
import Banner from './shared/banner'
import Config from './shared/config'
import Countdown from './shared/countdown'
import CustomSelect from './shared/custom-select'
import DragScroll from './shared/drag-scroll'
import Faq from './shared/faq'
import Footer from './shared/footer'
import Header from './shared/header'
import { createLogin } from '@xolo/common/login'
import Modal from './shared/modal'
import Navigation from './shared/navigation'
import Referral from './shared/referral'
import Session from './shared/session'
import ShowMore from './shared/show-more'
import Carousel from './shared/carousel'
import Signup from './shared/signup'
import Ticker from './shared/ticker'
import Utility from './shared/utility'
import SearchRedirect from './shared/search-redirect';
import Toggle from './shared/toggle';

window.Autoplay = Autoplay;
window.Animations = Animations;
window.Banner = Banner;
window.Config = Config;
window.Countdown = Countdown;
window.CustomSelect = CustomSelect;
window.DragScroll = DragScroll;
window.Faq = Faq;
window.Footer = Footer;
window.Header = Header;
const Login = createLogin({
    csrfUrl: $("meta[name='_root_url']").attr("content") + 'csrf'
});
window.Login = Login;
window.Modal = Modal;
window.Navigation = Navigation;
window.Referral = Referral;
window.Session = Session;
window.ShowMore = ShowMore;
window.Carousel = Carousel;
window.Signup = Signup;
window.Ticker = Ticker;
window.Utility = Utility;
window.SearchRedirect = SearchRedirect;
window.Toggle = Toggle;

$(function () {
    Autoplay.init();
    Animations.init();
    Banner.init();
    Countdown.init();
    CustomSelect.init();
    DragScroll.init()
    Faq.init();
    Footer.init();
    Header.init();
    Login.init();
    Modal.init();
    Navigation.init();
    Referral.init();
    Carousel.init();
    Signup.init();
    Utility.init();
    ShowMore.init();
    SearchRedirect.init();
    Ticker.init();
    Toggle.init();
});
